export const isLateSubmission = (dueOn, submittedOn) =>
  dueOn
    ? new Date(submittedOn).getTime() - new Date(dueOn).getTime() > 0
    : false;
